module.exports = __webpack_public_path__ + "media/images/pic/sample1-0e2687e3a6c95084e6ce912aa45d3803.webp";